import React from 'react';

import { ServiceProviderChildFormProps } from '../../../../types/serviceProviders/editServiceProvider';
import FormBuilder from '../../../components/FormBuilder';
import { getServiceProviderDetailsFields } from '../../utils/constants';

const ServiceProviderDetailsForm = (props: ServiceProviderChildFormProps) => {
  const { userType } = props;

  return (
    <FormBuilder
      oneColumn
      formFragment
      layout="horizontal"
      fields={getServiceProviderDetailsFields(userType)}
    />
  );
}

export default ServiceProviderDetailsForm;
